import React, { useEffect, useState } from "react";
import {
  useSearchParams
} from "react-router-dom";
import { Link } from "react-router-dom";
import s from './tasks.module.css';
import cardGamesPng from'../asset/card-games.png';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate } from "react-router-dom";
import {Form} from 'react-bootstrap';

import {GreenButton, BlueButton, RedButton} from '../components/MyButton';

export default function Tasks() {
	const navigate = useNavigate();
	const [tasks, setTasks] = useState([]);
	const [taskLits, setTaskLits] = useState([]);
	const [taskDetails, setTaskDetails] = useState([]);
	
	const [cFilter, setCFilter] = useState(1);
	const [lang, setLang] = useState('hk');
	
	const fetchData = () => {		
		getData('taskApi/listAll', navigate)
		.then(res => {
				setTasks(res.data);
				setTaskLits(res.data);
			}
		);
	}
	
	const fetchDetailData = async () => {		
		await getData('taskApi/listAllDetail', navigate)
		.then(res => {
				setTasks(res.data);
				setTaskDetails(res.data);
			}
		);
	}
	
	useEffect(() => {
		if(cFilter == 1) {
			if (taskLits.length == 0) {
				fetchData();
			} else {
				setTasks(taskLits);
			}
		} else {
			if (taskDetails.length == 0) {
				fetchDetailData();
			} else {
				setTasks(taskDetails);
			}
		}
	}, [cFilter]);
	
	
	const [show, setShow] = useState(false);
	const [cTaskIdx, setCTaskIdx] = useState();
	
	const editTask = async (indexV) => {
		if (taskDetails.length == 0) {
			await fetchDetailData();
		}
		
		setCTaskIdx(indexV);
		setShow(true);
	}
	
	const confirmUpdate = () => {
		let obj = taskDetails[cTaskIdx];
		
		postData("taskApi/updateTask", obj, navigate);
	}
	
	const addChoice = async () => {
		let taskId = taskDetails[cTaskIdx].id;
		let obj = {taskId};
		
		postData("taskApi/addChoice", obj, navigate)
			.then(res => {
				let tmp =  [...taskDetails];
				tmp[cTaskIdx].choices.push(res.data);
				setTaskDetails(tmp);
			}
		);
		
	}
	
	const addOutcome = (choiceId, indexC) => {
		let taskId = taskDetails[cTaskIdx].id;
		let obj = {taskId, choiceId};
				
		postData("taskApi/addOutcome", obj, navigate)
			.then(res => {
				let tmp =  [...taskDetails];
				tmp[cTaskIdx].choices[indexC].outcomes.push(res.data);
				setTaskDetails(tmp);
			}
		);
		
	}
	
	const [cTab, setCTab] = useState(1);	
	
	return (
		<div>
		
			<div className={show ? s.modal : s.modal_hide}>
				<div className={s.modal_contentWrapper}>
					{
						(show) && (<div className={s.taskList_Modal_Id}>
							<div>Task ID: {taskDetails[cTaskIdx].id}</div>
							<div className={s.confirmButton}><RedButton isEnabled={true} clickedAction={()=>confirmUpdate()} bText={"update"} /></div>
						</div>)
					}
						<li className={s.toggleOptionHolder}>
							<ul className={(cTab == 1) ? s.toggleOptionOn : ""} onClick={()=>setCTab(1)}>Main</ul>
							<ul className={(cTab == 2) ? s.toggleOptionOn : ""} onClick={()=>setCTab(2)}>Reqs</ul>
						</li>
					{
					(show && cTab == 1) && (<div className={s.taskList_Holder}>
						<div className={s.taskList_Detail}>
							<div className={s.taskList_Modal_Comment}>
								<div>{taskDetails[cTaskIdx].comment}</div>
								<div className={s.addButtonMain}><BlueButton isEnabled={true} clickedAction={()=>addChoice()} bText={"+"} /></div>
							</div>
							<div className={s.taskList_Comment}>
								<Form.Control type="text" value={taskDetails[cTaskIdx].description_en} placeholder="Eng"
									onChange={e => { 
											let tmp = [...taskDetails];											
											tmp[cTaskIdx].description_en = e.target.value;
											setTaskDetails(tmp);
									}} />
							</div>
							<div className={s.taskList_Comment}>
								<Form.Control type="text" value={taskDetails[cTaskIdx].description_hk} placeholder="中文"
									onChange={e => { 
											let tmp = [...taskDetails];											
											tmp[cTaskIdx].description_hk = e.target.value;
											setTaskDetails(tmp);
									}} />
							</div>
							{
								(taskDetails[cTaskIdx].choices) && taskDetails[cTaskIdx].choices.map((c, indexC) => (
									<div className={s.taskDetail_Holder}>
										<div className={s.taskList_choices_Id}>
											<div>{c.id}</div>
											<div className={s.addButton}><GreenButton isEnabled={true} clickedAction={()=>addOutcome(c.id, indexC)} bText={"+"} /></div>
										
										
										</div>
										<div className={s.taskList_choices_Holder}>
											<div className={s.taskList_choices_descEn}>
												<Form.Control type="text" value={c.description_en} placeholder="Eng"
													onChange={e => { 
															let tmp = [...taskDetails];											
															tmp[cTaskIdx].choices[indexC].description_en = e.target.value;
															setTaskDetails(tmp);
													}} />
											</div>
											<div className={s.taskList_choices_descEn}>
												<Form.Control type="text" value={c.description_hk} placeholder="中文"
													onChange={e => { 
															let tmp = [...taskDetails];											
															tmp[cTaskIdx].choices[indexC].description_hk = e.target.value;
															setTaskDetails(tmp);
													}} />
											</div>
											
											{
												c.outcomes.map((o, indexO) => (
													<div className={s.taskList_outcomes_Holder}>
														<div className={s.taskList_outcomes_Id}>{o.id}
														</div>
														<div className={s.taskList_outcomes_detail_Holder}>
															<div>
																<Form.Control type="text" value={o.description_en} placeholder="Eng"
																onChange={e => { 
																		let tmp = [...taskDetails];											
																		tmp[cTaskIdx].choices[indexC].outcomes[indexO].description_en = e.target.value;
																		setTaskDetails(tmp);
																}} />			
															</div>
															<div>
																<Form.Control type="text" value={o.description_hk} placeholder="中文"
																onChange={e => { 
																		let tmp = [...taskDetails];											
																		tmp[cTaskIdx].choices[indexC].outcomes[indexO].description_hk = e.target.value;
																		setTaskDetails(tmp);
																}} />			
															</div>
														</div>
													</div>
												))
											}
											
										</div>								
									</div>))
							}
						</div>
					</div>)
					}
					{
						(show && cTab == 2) && (<div className={s.requirement_Holder}>
							<div>Requirement</div>
							<div>
								{
									taskDetails[cTaskIdx].taskRequirement.map(tr=>(<div>
										{tr.id}
										{tr.type}
										{tr.detail}
									</div>))
								}
							</div>
							<div>Trigger Override</div>
						</div>)
					}
				</div>
				<div className={s.modal_backdrop} onClick={()=>{ setShow(false)}}/>
			</div>
			
			
			
			
			<div className={s.navbar}>
				<div>
					status <GreenButton isEnabled={true} clickedAction={()=>setCFilter((cFilter == 1) ? 2 : 1)} bText={cFilter} />
					status <GreenButton isEnabled={true} clickedAction={()=>setLang((lang=='hk') ? 'en' : 'hk')} bText={lang} />
				</div>
				<div>
					<img className={s.createCardIcon} src={cardGamesPng} alt="icon"/>
				</div>
			</div>
			
			<div className={s.cardList}>
				<div className={s.taskList_header_Holder}>
					<div className={s.taskList_Id}>id</div>
					<div className={s.taskList_Detail}>comment</div>
				</div>
			
				{
					tasks.map((v, IndexV)=>(<div key={'v' + v.id} className={s.taskList_Holder}>
							<div className={s.taskList_Id} onClick={()=>editTask(IndexV)}>{v.id}</div>
							<div className={s.taskList_Detail}>
								<div className={s.taskList_Comment}>{v.comment}</div>
								<div className={s.taskList_Comment}>{v['description_' + lang]}</div>
								{
									(v.choices) && v.choices.map((c) => (
										<div className={s.taskDetail_Holder}>
											<div className={s.taskList_choices_Id}>{c.id}</div>
											<div className={s.taskList_choices_Holder}>
												<div className={s.taskList_choices_descEn}>{c['description_' + lang]}</div>
												
												{
													c.outcomes.map((o) => (
														<div className={s.taskList_outcomes_Holder}>
															<div className={s.taskList_outcomes_Id}>{o.id}</div>
															<div className={s.taskList_outcomes_detail_Holder}>
																<div>{o['description_' + lang]}</div>
															</div>
														</div>
													))
												}
												
											</div>								
										</div>))
								}
						</div>
					</div>))
				}
			</div>
		
		</div>)
}